<template>
  <div class="container mt-md-5 col-md-6 p-4">
    <div class="row" v-if="loading">
      <h2>{{ player.name }}</h2>
      <p><strong>{{ $t('player.number') }}
        :</strong> {{ player.number }}</p>

      <h2 class="text-uppercase">{{ $t('player.statistic') }}</h2>
      <div class="d-flex flex-wrap gap-1" v-if="stats">
        <span class="badge bg-secondary p-2">{{ $t('player.games') }}: {{ stats.games }}</span>
        <span class="badge bg-secondary p-2">{{ $t('player.atbat') }}: {{ stats.atbat }}</span>
        <span class="badge bg-secondary p-2">{{ $t('player.average') }}: {{ stats.average }}</span>
        <span class="badge bg-secondary p-2">{{ $t('player.hits') }}: {{ stats.hits }}</span>
        <span class="badge bg-secondary p-2">{{ $t('player.outs') }}: {{ stats.outs }}</span>
        <span class="badge bg-secondary p-2">{{ $t('player.safe') }}: {{ stats.safe }}</span>
      </div>
      <h2 class="text-uppercase mt-2">{{ $t('player.heatmap') }}</h2>
      <div class="col-12">
        <div class="col-md-9" style="position: relative;">
          <div class="field-wrapper">
            <img alt="bb5-field" class="img-fluid" src="../assets/field.jpg"/>
            <heatmap v-if="heatmapData && heatmapData.length" :playerstats="heatmapData"></heatmap>
          </div>
        </div>
      </div>
      <div class="col-12 mt-3">
        <button class="col-6 btn btn-bb5-black m-0 p-2" @click="goBack">{{ $t('back') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import core from "@/mixins/Core";
import Heatmap from "@/components/Heatmap.vue";

export default {
  name: "PlayerDetail",
  components: {Heatmap},
  props: {
    playerId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      player: {
        name: "",
        number: 0,
      },
      team: null,
      stats: {},
      heatmapData: {},
      loading: false,
    };
  },
  mixins: [core],
  computed: {
    ...mapState(["teams", "playerStats"]),
  },
  methods: {
    async loadData() {
      // Spieler- und Teamdaten abrufen
      const playerData = await this.getData('players', this.playerId);
      const playerStats = await this.getData('getplayerstats', this.playerId, 'local');

      // Überprüfen, ob playerData existiert
      if (playerData && playerData.player) {
        this.player = playerData.player;
      } else {
        console.error("playerData konnte nicht geladen werden oder ist ungültig.");
        return; // Methode beenden, wenn playerData nicht existiert
      }

      // Überprüfen, ob playerStats existiert
      if (playerStats && playerStats.stats) {
        this.heatmapData = playerStats.stats;
      } else {
        console.error("playerStats konnte nicht geladen werden oder ist ungültig.");
        this.heatmapData = []; // Sicherstellen, dass heatmapData leer ist
      }

      this.stats = await this.calculateStatistics();
      this.loading = true;
    },
    async calculateStatistics() {
      const gamesData = await this.getData('getAllGames') || [];
      const stats = {
        hits: 0,
        outs: 0,
        safe: 0,
        atbat: 0, // Total (Summe aus allen Aktionen)
        games: 0,
      };
      gamesData.forEach(({game}) => {
        // Sicherstellen, dass `game` ein Array ist
        if (!Array.isArray(game)) return;
        // Prüfen, ob der Spieler in diesem Spiel vertreten ist
        const playerInGame = game.some(entry => entry.player && entry.player.id === this.playerId);

        // Wenn der Spieler in diesem Spiel vertreten ist, erhöhen wir die Spielanzahl
        if (playerInGame) stats.games += 1;

        // Über jeden Eintrag im `game`-Array iterieren
        game.forEach((entry) => {
          // Nur Aktionen für den aktuellen Spieler berücksichtigen
          if (entry.player && entry.player.id === this.playerId) {
            // Je nach `action` den entsprechenden Zähler erhöhen
            if (entry.action === "H") stats.hits += 1;
            if (entry.action === "O") stats.outs += 1;
            if (entry.action === "S") stats.safe += 1;
            // Jede Aktion zählt als "atbat"
            stats.atbat += 1;
          }
        });
      });
      if (stats.atbat > 0) {
        stats.average = (stats.hits / stats.atbat).toFixed(3); // 3 Dezimalstellen für die Average
      }

      return stats; // Statistik zurückgeben
    },

    goBack() {
      this.$router.push("/players"); // Navigiert zur Player-Hauptliste
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style scoped>
.player-detail {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.heatmap-container {
  margin-top: 20px;
}
</style>